<template>
  <Component
    :is="tag"
    class="rs-prop-type"
  >
    {{ text }}
  </Component>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsPropType',
  props: {
    text: String,
    tag: {
      type: String,
      default: 'span',
    },
  },
});
</script>
<style lang="scss" scoped>
@import '@/styles/_variables.scss';
.rs-prop-type{
  font-weight: 400;
  font-size: rem-calc(12);
  color: darken($primary-color, 5%);
}
</style>
